/* eslint-disable import/prefer-default-export */

import {SET_PERSISTENT_VARIABLE, SET_RUNTIME_VARIABLE, CLEAR_PERSISTENT_VARIABLES} from '../constants';

export function setRuntimeVariable({ name, value }) {
    return {
        type: SET_RUNTIME_VARIABLE,
        payload: {
            name,
            value,
        },
    };
}

export function setPersistentVariable({ name, value }) {
    return {
        type: SET_PERSISTENT_VARIABLE,
        payload: {
            name,
            value,
        },
    };
}

export function clearPersistentVariables() {
    return {
        type: CLEAR_PERSISTENT_VARIABLES,
        payload: {
        },
    };
}